import { BaseService } from 'core/services';
import ClinicalStatusRouteService from './ClinicalStatusRouteService';

class ClinicalStatusService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ClinicalStatusRouteService());
    }
}

export default ClinicalStatusService;
